import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import Product from 'src/app/model/product/product';
import { FormatDecimal } from 'src/app/pipes/format-decimal';
import ProductSize from 'src/app/model/product/product-size';
import CustomWindowsticker from '../../../../model/product/windowsticker/custom-windowsticker';

@Component({
  selector: 'internal-invoice',
  templateUrl: './internal-invoice.component.html',
  styleUrls: ['./internal-invoice.component.scss'],
  providers: [FormatDecimal],
})
export class InternalInvoiceComponent implements OnInit {
  inputCustomSticker: CustomWindowsticker;
  @Input()
  public inputProduct: Product;

  @Input()
  public updateEmitter: EventEmitter<any>;

  constructor(private formatDecimal: FormatDecimal) {}

  ngOnInit() {
    if (this.isCustomWindowSticker()) {
      this.inputCustomSticker = <CustomWindowsticker>this.inputProduct;
      this.inputCustomSticker.needsInvoice = true;
      if (this.inputCustomSticker.productionPrice == null) {
        this.inputCustomSticker.productionPrice = 0;
      }
      if (this.inputCustomSticker.placementPrice == null) {
        this.inputCustomSticker.placementPrice = 0;
      }
      this.inputProduct = this.inputCustomSticker;
    }
  }

  needsInvoiceChange(event) {
    this.inputProduct.needsInvoice = event;
    this.updateEmitter.emit();
  }

  extraInfoInvoiceChange(event) {
    // this.inputProduct.extraInfoInvoice = event;
    this.updateEmitter.emit();
  }

  isWindowSticker() {
    if (this.inputProduct.type == 'WindowSticker') {
      return true;
    }
  }

  isCustomWindowSticker() {
    if (this.inputProduct.type == 'CustomWindowSticker') {
      return true;
    }
  }

  pricesPicked(event) {
    this.inputCustomSticker.prices = event;
    this.inputProduct = this.inputCustomSticker;
    this.updateEmitter.emit();
  }

  displaySumCustom(product: CustomWindowsticker) {
    if (product == null) {
      return this.formatDecimal.transform(0, true, 2);
    } else {
      return this.formatDecimal.transform(
        product.productionPrice + product.placementPrice,
        true,
        2
      );
    }
  }

  setProductionPriceCustom(event) {
    this.inputProduct = this.inputCustomSticker;
    this.updateEmitter.emit();
  }

  setPlacementPriceCustom(event) {
    this.inputProduct = this.inputCustomSticker;
    this.updateEmitter.emit();
  }

  displayProductionPrice(productSize: ProductSize) {
    if (productSize == null) {
      return this.formatDecimal.transform(0, true, 2);
    } else {
      return this.formatDecimal.transform(productSize.productionPrice, true, 2);
    }
  }

  displayPlacementPrice(productSize: ProductSize) {
    if (productSize == null) {
      return this.formatDecimal.transform(0, true, 2);
    } else {
      return this.formatDecimal.transform(productSize.placementPrice, true, 2);
    }
  }

  displaySum(productSize: ProductSize) {
    if (productSize == null) {
      return this.formatDecimal.transform(0, true, 2);
    } else {
      return this.formatDecimal.transform(
        productSize.productionPrice + productSize.placementPrice,
        true,
        2
      );
    }
  }
}
